/**
 * Error messages raised by in-app browser host bridges that the website cannot
 * control or fix from JavaScript.
 *
 * The Instagram/Facebook in-app browser (Android WebView) injects its own
 * JavaScript-to-Java bridge. When the native Java object is collected while a
 * `postMessage` call is still in flight, the bridge throws
 * `Error invoking postMessage: Java object is gone`. When the native Java method
 * itself raises, the bridge throws
 * `Error invoking postMessage: Java exception was raised during method invocation`.
 *
 * In both cases the call happens in the host application's injected script, not
 * in website code — nothing under `projects/frontend/apps/website` calls
 * `postMessage` — so the website cannot wrap the call in `try/catch`. It can only
 * keep the failure out of the application error stream.
 *
 * Both signatures are separate Sentry issues because they are separate throw
 * sites in the host bridge (missing native object vs. exception inside the Java
 * method); declaring each pattern explicitly documents why the event is dropped
 * and keeps the treatment independent of the installed SDK's default
 * `ignoreErrors` list.
 *
 * References: Sentry issues WEBSITE-0O-X (ticket CD-1681) and WEBSITE-0O-Y
 * (ticket CD-1682).
 */
export const THIRD_PARTY_WEBVIEW_BRIDGE_IGNORE_ERRORS: readonly RegExp[] = [
  // Unanchored at the start so both the bare message and prefixed variants such
  // as `Error: Error invoking postMessage: ...` are matched.
  /Error invoking postMessage: Java object is gone$/,
  /Error invoking postMessage: Java exception was raised during method invocation$/,
];
